// Utilities for business schedules

export const getDefaultSchedule = () => {
  return [
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
    {
      enabled: true,
      lapses: [
        { open: { hour: 0, minute: 0 }, close: { hour: 23, minute: 59 } },
      ],
    },
  ];
};

export default {
  getDefaultSchedule,
};
